import React from 'react';
import PropTypes from 'prop-types';
import { Button } from './button.style';

const ButtonComponent = ({
    type = 'button',
    label = 'Button',
    icon: Icon,
    outline = false,
    size = 'medium',
    fullWidth = false,
    upperCase = false,
    color,
    rounded = false,
    ...props
}) => {     
    return (
        <Button
            type={type}
            $outline={outline}
            size={size}
            $fullwidth={fullWidth}
            $uppercase={upperCase}
            color={color}
            $rounded={rounded}
            {...props}
        >
            {Icon && <Icon />}
            {label}
        </Button>
    );
};

ButtonComponent.propTypes = {
    type: PropTypes.oneOf(['button', 'submit']),
    label: PropTypes.string,
    icon: PropTypes.elementType,
    outline: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    fullWidth: PropTypes.bool,
    upperCase: PropTypes.bool,
    color: PropTypes.oneOf(['default', 'success', 'error', 'warning']),
    rounded: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
};

export default ButtonComponent;
